import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import PDFIcon from 'Images/fileIcons/pdf-icon.png';
import ExcelIcon from 'Images/fileIcons/icon-excel.png';
import PPTIcon from 'Images/file_icons/PPT.svg';
import WordIcon from 'Images/fileIcons/icon-word.png';
import ZipIcon from 'Images/file_icons/ZIP.svg';

import LaunchIcon from '@mui/icons-material/FileDownloadOutlined';
import { ERROR_MESSAGES } from 'Utils/constants';
import { http } from "Utils/http";
import { store } from 'Store';
import { getLoggedInUserInfo, getDocumentInfo } from "Utils/utilityFunctions";
import React, { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux"
import { httpDownload } from 'Utils/httpDownload';
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import {Button, Col, Row} from 'react-bootstrap';
import { LinkButton, TextButton } from 'Components/Button';


const DocumentPublicDownload = ({groupId, pageName, linkTitle, linkText, errorHandle}) => {
    const [userData, setUserData] = useState(null);
    const [docBean, setDocBean] = useState(null);
    const [docRoles, setDocRoles] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const dispatch = useDispatch();
    const loginInfo = useSelector(state => state.loginInfo);
    const [isLoading, setIsLoading] = useState(true);

    const getDocumentDownloadCall = async (groupId) => {   
 
        //console.log(groupId);
        var url = '/api/dlms/downloadDocument';
        const loginState = store.getState().loginInfo;
        
        return httpDownload.post(url, {"groupId": groupId},{ 
            responseType: 'blob',
            headers: {
                "Authorization": "Bearer " + loginInfo.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const handleFileDownload = async (groupId, fileName) => {
        const res = await getDocumentDownloadCall(groupId);
        
    
        if (res) {
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
          // get filename from the res content-disposition
          const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            //console.log(filename)
          let url = window.URL.createObjectURL(res.data);
          let a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a); // append the element to the dom
          a.click();
          a.remove(); // afterwards, remove the element  
        }
      }
   
    const getDocInfo = (groupId, errorHandle) => {
        setIsLoading(true);

        if(groupId!=null && groupId!=""){
            getDocumentInfo(groupId, errorHandle).then((res) => {
                //console.log(res);
                setStatusCode(res.status);
                if (res.status != 1) {
                    if(res.globalErrorMessageList!=null && res.globalErrorMessageList.length>0){
                        setErrorMessage(res.globalErrorMessageList[0]);
                    }
                }
                else {
                    var d = res.data;
                    setDocBean(d.documentTagInfo);
                    setDocRoles(d.allRoles);
                    setUserData(d.loggedInUserRole);
                }
            
                setIsLoading(false);
                return res;
            }).catch((error) => {
                //console.log("Error caught while loading data: " + error);

                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: error
                });
                setIsLoading(false);
            });
        }
        else{
            setStatusCode(-1);
            setErrorMessage("Missing Document Group ID!");
        }
        
        setIsLoading(false);
    }

    const equalsIgnoreCase = (s1, s2)=> {
        return s1.toLowerCase() == s2.toLowerCase();
    }

    const getFileSizeKB = (value) => {
        if (value <= 0)
            return "0 KB";

        var size = value/1024;

        var decimalFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0, style: 'decimal' }).format(
            size
        );
        
        return decimalFormat + " KB";
    }

    useEffect(() => {
        getDocInfo(groupId, errorHandle);
    }, []);

    /*useEffect(()=>{
        //console.log(groupId);
        getDocInfo(groupId, errorHandle);

    },[groupId, pageName, linkTitle, linkText])*/
    
    const [gId, setGId] = useState(groupId);
    const [pName, setPName] = useState(pageName);
    const [lTitle, setLTitle] = useState(linkTitle);
    const [lText, setLText] = useState(linkText);

    function getOutput(hasFileImg, fileImage, imageAlt, postedOn) {
        //if(hasFileImg==true) {
            var output = null;
                    
            return (
                <div className="d-flex gap-2 flex-column">
                    <div className="document-link-container d-flex align-items-start">
                        {
                            hasFileImg==true
                            ? <img src={fileImage} alt={imageAlt + " icon"} width='26' height='26' align='top' className='me-2 mt-3 mb-2'/>
                            : null
                        }
                        {
                            pName === "Resources" ?
                              <div className={`py-1`}>
                                  <p className='h5 m-0 p-1 px-md-2 body'>
                                    <TextButton variant={"comp-link"} size={"inherit"} className="resources-doc-link me-4 text-start" content={docBean.docDisplayName} onClick={() => handleFileDownload(groupId)}></TextButton>
                                    <span className={`resources-doc-info body mt-1 `}>{" Posted On: " + postedOn + ", " + getFileSizeKB(docBean.docSize)}</span>
                                  </p>
                              </div>
                              :
                            linkTitle!=null && linkText!=null && linkTitle!="" && linkText!=""
                            ?   <div> 
                                    <LinkButton onClick={()=>handleFileDownload(groupId)} /*href={'/DLMS/downloadDocument?groupId=' + groupId + "&pageName=" + pageName}*/  
                                        className='me-2 document-link' title={linkTitle}
                                        content={linkText+ (
                                          pName === "Resources" ?
                                            "Posted On: " + postedOn + ", " + getFileSizeKB(docBean.docSize)
                                            :
                                            ""
                                        )}
                                        external={false}
                                    >
                                        <span className="d-inline-block mt-1">
                                            {linkText}
                                        </span>
                                        <LaunchIcon className="ms-2 mb-1 "></LaunchIcon>
                                        
                                    </LinkButton>
                                    {/*<div className="additional-document-info">
                                        {
                                            postedOn!=null && postedOn!=""
                                            ? <p> Posted on: {postedOn}</p>
                                            : null
                                        }
                                    </div>*/}
                                </div>
                            :   <div> 
                                    <LinkButton onClick={()=>handleFileDownload(groupId)}
                                        content={docBean.docDisplayName+ (
                                          pName === "Resources" ?
                                            "Posted On: " + postedOn + ", " + getFileSizeKB(docBean.docSize)
                                            :
                                            ""
                                        )}
                                        external={false}
                                        /*href={'/DLMS/downloadDocument?groupId=' + groupId + "&pageName=" + pageName}*/ className='me-2 document-link' title={"Download " + imageAlt + " " + docBean.docDisplayName}
                                    >
                                        <span className="d-inline-block mt-1">
                                            {docBean.docDisplayName}
                                            <span className="additional-document-info">{"Posted on: "+postedOn+", "+getFileSizeKB(docBean.docSize)}</span>
                                        </span>
                                        <LaunchIcon className="ms-2 mb-1 "></LaunchIcon>
                                        
                                    </LinkButton>
                                    {/*<div className="additional-document-info">
                                        {
                                            postedOn!=null && postedOn!=""
                                            ? <p> Posted on: {postedOn}, {getFileSizeKB(docBean.docSize)}</p>
                                            : <p>, {getFileSizeKB(docBean.docSize)}</p>
                                        }
                                    </div>*/}
                                </div>
                        }
                        
                    </div>
                    {   pName !== "Resources" && (
                        linkTitle!=null && linkText!=null && linkTitle!="" && linkText!=""
                        ?   <div>
                                
                                <div className="additional-document-info">
                                    {
                                        postedOn!=null && postedOn!=""
                                        ? <p> Posted on: {postedOn}</p>
                                        : null
                                    }
                                </div>
                            </div>
                        :   <div>
                                
                                <div className="additional-document-info">
                                    {
                                        postedOn!=null && postedOn!=""
                                        ? <p> Posted on: {postedOn}, {getFileSizeKB(docBean.docSize)}</p>
                                        : <p>, {getFileSizeKB(docBean.docSize)}</p>
                                    }
                                </div>
                            </div>
                    )}
                    
                </div>
                

                
            );
        //}
        
    }

    function getErrorOutput(){
        return (
            <div className="document-link-container d-flex">
                <div >
                    <div className='me-2 d-flex document-link error align-items-center' >
                        <p>{errorMessage}</p>
                        <ErrorIcon className="ms-2 "></ErrorIcon>
                        
                    </div>
                    <div className="additional-document-info">
                        
                    </div>
                </div>
            </div>
        )
    }

    
    
    function getDisplay () {
        if(pName==null) {
            setPName('');
        }
        if(groupId == null || groupId=="") {
            return getErrorOutput("Missing Document Group ID!");
            /* (
                <h2>ERROR</h2>
                buff.append("<img src='/images/messages/error.png'");
                buff.append(" alt='error' width='22' height='22' align='top'>&nbsp;&nbsp;");
                buff.append("Missing Document Group ID!");
                buff.append("</p>");
            );*/
        }
        else {
            if(statusCode!=1){
                return getErrorOutput("ERROR");
            }
            var fileImage = null;
            var imageAlt = null;
            //DocumentTagInfo
            //var docInfo = null; //getDocTagInfoCall
            //console.log(docBean);
            if(docBean != null && docBean.docId != null && docBean.docId > 0) {
                
                var allowAccessDoc = false;
                if ( !"Y"===(docBean.allowPublicAccess)) {
                    //var user = getLoginUser();
                    if(userData!=null){
                        // check user role against document assigned role
                        var userRole = userData.roleId;

                        if (docRoles != null && docRoles.length > 0) {
                            for (var i = 0; i < docRoles.length; i++) {
                                if (userRole===docRoles[i]) {
                                    allowAccessDoc = true;
                                    break;
                                }
                            }

                        } else{
                            allowAccessDoc = false;
                        }
                            
                    }
                }
                else{
                    allowAccessDoc=true;
                }
                if (allowAccessDoc) {

                    // Images: icon-excel.png, icon-pdf.png,
                    // icon-powerPoint.png, icon-word.png, zip.png
                    // File Ext: "doc", "docx", "pdf", "ppt", "pptx", "xls", "xlsx", "zip"

                    // decide document image icon base on file extension
                    var fileExt = docBean.docExt;
                    if (equalsIgnoreCase("doc",fileExt) || equalsIgnoreCase("docx",fileExt) ) {

                        fileImage = WordIcon;//"icon-word.png";
                        imageAlt = "word document";
                    } 
                    else if (equalsIgnoreCase("ppt",fileExt) || equalsIgnoreCase("pptx",fileExt)) {    

                        fileImage = PPTIcon;
                        imageAlt = "power point document";
                    } 
                    else if (equalsIgnoreCase("pdf",fileExt)) {    

                        fileImage = PDFIcon;//"icon-pdf.png";
                        imageAlt = "PDF document";
                    } 
                    else if (equalsIgnoreCase("xlsx",fileExt)  || equalsIgnoreCase("xls",fileExt) ) {    

                        fileImage = ExcelIcon;
                        imageAlt = "excel document";
                    } 
                    else if (equalsIgnoreCase("zip",fileExt)) {    

                        fileImage = ZipIcon;
                        imageAlt = "zip file";
                    }

                    //if (linkText != null && linkTitle != null) {
                        /*
                        * user provide linkText and linkTitle, build in different format:
                        * <p><img src="/images/icon-pdf.png" alt="work document icon" width="22" height="22" align="top">
                        * <a href="#" title="linkTitle">linkText</a></p>
                        */
                        //buff.append("<p>");

                        //if (fileImage != null) {
                            
                            /*buff.append("<img src=\"/images/" + fileImage);
                            buff.append("\" alt=\"" + imageAlt + " icon\" ");
                            buff.append("width='22' height='22' align='top'>&nbsp;&nbsp;");*/
                        //}

                        /*buff.append("<A href='/DLMS/downloadDocument?groupId=" + groupId + "&pageName=" + pageName);
                        buff.append("' title='");
                        buff.append(lTitle);
                        buff.append("'>");
                        buff.append(lText);
                        buff.append("</A></p>");*/

                        //return getOutput(fileImage != null, fileImage, imageAlt, null);

                    //} 
                    //else {
                        //buff.append("<p>");

                        //if (fileImage != null) {
                            //buff.append("<img src=\"/images/" + fileImage);
                            //buff.append("\" alt=\"" + imageAlt + " icon\" ");
                            //buff.append("width='22' height='22' align='top'>&nbsp;&nbsp;&nbsp;");
                        //}

                        // add <A> tag:
                        // <a href="#">PPC Website Registration Process FAQ&rsquo;s</a> Posted on 08/30/2011, 113 KB</p>
                        
                        /*buff.append("<A href='/DLMS/downloadDocument?groupId=" + groupId + "&pageName=" + pageName);
                        buff.append("' title='");
                        buff.append("Download " + imageAlt + " " + docInfo.docDisplayName);
                        buff.append("'>");
                        buff.append(docInfo.docDisplayName());
                        buff.append("</A>");*/

                        
                        

                        //buff.append(",&nbsp;&nbsp;" + Format.displayFileSizeKB(docInfo.docSize));
                        //buff.append("</p>");
                    //}
                    return getOutput(fileImage != null, fileImage, imageAlt, docBean.postedOn);
                }
                else{
                    return getErrorOutput("ERROR");
                }
            }
            else{
                return getErrorOutput("No doc ID");
            }
        }
    }
    
    return (
        isLoading==false && docBean!=null
            ? getDisplay()
            : null
        
    )
    
}

export default DocumentPublicDownload;